import Service from './Service';

class RePayService {
  constructor() {
    this.PATH = {
      SUIT_CURRENT: 'b/suit/current',
      AVAILABLE_SUIT: 'b/suit/availableSuits'
    };
  }

  getCurrentSuit() {
    const params = {};
    const { SUIT_CURRENT } = this.PATH;

    return Service.doAsyncRequest(SUIT_CURRENT, {
      params, queryUserInfo: false
    });
  }
}

export default new RePayService();



// WEBPACK FOOTER //
// ./src/service/RenewPayService.js